// extracted by mini-css-extract-plugin
export default {"wrapper":"QuotaCleanerPage__wrapper--1g-o0","list":"QuotaCleanerPage__list--3QHOA","toolbar":"QuotaCleanerPage__toolbar--1sd_u","dataList":"QuotaCleanerPage__dataList--Hw5aP"};